export const env = {
  production: process.env.NODE_ENV === 'production',
  development: process.env.NODE_ENV !== 'production',
};

export const RAVEN_CLIENT_KEY = 'https://a0c9bc447e054251a8468d64e3291dc1@o2127.ingest.sentry.io/6438949';
export const RAVEN_OPTIONS = {
  release: process.env.REVISION || 'latest',
  sampleRate: 0.1,
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'http://tt.epicplay.com',
    'Can\'t find variable: ZiteReader',
    'jigsaw is not defined',
    'ComboSearch is not defined',
    'http://loading.retry.widdit.com/',
    'atomicFindClose',
    // Facebook borked
    'fb_xd_fragment',
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    'conduitPage',
    // CORS
    /Error: There is no clipping info for given tab/,
    // eslint-disable-next-line max-len
    'SecurityError: Blocked a frame with origin "https://ridibooks.com" from accessing a frame with origin "https://bid.g.doubleclick.net". Protocols, domains, and ports must match.',
    // eslint-disable-next-line max-len
    'SecurityError: Blocked a frame with origin "https://ridibooks.com" from accessing a cross-origin frame. Protocols, domains, and ports must match.',
    // See https://github.com/SamsungInternet/support/issues/56
    'document.getElementsByClassName.ToString is not a function',
    // NAVER App (See https://developers.naver.com/forum/posts/21372)
    'Cannot call method \'checkDomStatus\' of undefined',
    'Cannot read property \'checkDomStatus\' of undefined',
    // NAVER App
    'Cannot read property \'childNodes\' of null',
    'Can\'t find variable: NaverDetectLang',
    '/window.__naverapp__.extractMetadata/',
    // See https://stackoverflow.com/questions/49077748/androidinterface-is-not-defined-what-gives
    'androidInterface is not defined',
    // See https://bugs.chromium.org/p/chromium/issues/detail?id=590375
    'TypeError: undefined is not an object (evaluating \'__gCrWeb.autofill.extractForms\')',
    // Almost all occur in Google Chrome
    'Unexpected token else',
    // Triggered from an unknown linux user
    'Failed to execute \'postMessage\' on \'Window\': function (s){return eval(s);} could not be cloned',
    // IE, Edge only
    /^undefined$/,
    'Target container is not a DOM element.',
    // Chrome only
    'Cannot read property \'processEvent\' of undefined',
    'Unexpected identifier',
    'Failed to read the \'cssRules\' property from \'CSSStyleSheet\': Cannot access rules',
    // Facebook crawler. see https://app.asana.com/0/325622807541174/823860092252432
    'ReferenceError: _isMatchingDomain is not defined',

    // eslint-disable-next-line max-len
    'React is running in production mode, but dead code elimination has not been applied. Read how to correctly configure React for production',
  ],
  whitelistUrls: [
    /https?:\/\/(.+\.)?ridibooks\.com/,
    '<anonymous>',
  ],
};



// WEBPACK FOOTER //
// /static/store/src/app/common/config.js